import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgResizeHandle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M4.5 7.5L7.5 4.5M0.5 7.5L7.5 0.5",
		stroke: "black"
	})
});
export default SvgResizeHandle;
